<template>
  <div :class="noteCountClasses">
    <sx-tiny color="currentcolor">{{ noteCount }}</sx-tiny>
    <!-- <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 3.75L8.4 0H1.2C0.54 0 0 0.5625 0 1.25V8.75625C0 9.44375 0.54 10 1.2 10L10.8 9.99375C11.46 9.99375 12 9.4375 12 8.75V3.75ZM7.8 0.9375L11.1 4.375H7.8V0.9375Z" fill="currentcolor"/>
    </svg> -->
    <svg
      width="12"
      height="7"
      viewBox="0 0 12 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 7H8V5.83333H0V7ZM0 0V1.16667H12V0H0ZM0 4.08333H12V2.91667H0V4.08333Z"
        fill="currentcolor"
      />
    </svg>
  </div>
</template>

<script>
import SxTiny from './SxTiny';

export default {
  components: {
    SxTiny,
  },
  props: {
    noteCount: {
      type: Number,
      required: true,
    },
  },
  computed: {
    noteCountClasses() {
      const nClasses = new Set(['noteCount']);

      if (this.noteCount >= 1) nClasses.add('noteCount--active');

      return [...nClasses].join(' ');
    },
  },
};
</script>

<style scoped>
.noteCount {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 24px;
  padding: 0 6px;

  background-color: var(--gray-0);
  border: 1px solid var(--gray-100);
  border-radius: 4px;
  color: var(--gray-700);
}

.noteCount small {
  line-height: 24px;
}

.noteCount--active {
  background-color: var(--blue-100);
  border-color: var(--blue-200);
  color: var(--blue-600);
}
</style>
